module.exports = __webpack_public_path__ + "static/img/water_6.9746f39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/water_6.png
// module id = 7
// module chunks = 1